import React from 'react';
import CurrencyInputCell from '../../../ui/Table/Cells/CurrencyInputCell';
import { BookingsTableData, BookingsApiModel, BookingTableCellProps, NON_EDITABLE_BOOKING_STATUSES } from './helpers';
import useNonNullContext from '../../../hooks/useNonNullContext';
import { OptionsContext } from '../../../contexts/OptionsContext';

type BookingPriceCellProps<T extends BookingsTableData> = BookingTableCellProps<T> & {
    updateBooking?: (id: number, data: BookingsApiModel) => Promise<void>;
};

const BookingPriceCell = <T extends BookingsTableData>({ updateBooking, ...props }: BookingPriceCellProps<T>) => {
    const { currencies } = useNonNullContext(OptionsContext);
    const { currency, id, date_approved, status } = props.row.original;
    const disabled = Boolean(date_approved) || NON_EDITABLE_BOOKING_STATUSES.includes(status);

    return (
        <CurrencyInputCell
            {...props}
            disabled={disabled}
            currency={currencies.find((c) => c.id === currency)}
            onSubmit={async (value) => {
                if (typeof updateBooking === 'function' && value !== props.value) {
                    await updateBooking(id, { cost: value });
                }
            }}
            decimalsLimit={3}
        />
    );
};

export default BookingPriceCell;
